import LayerGroup from "ol/layer/Group";
import TileLayer from "ol/layer/Tile";
import {TileWMS} from "ol/source";
import VectorLayer from "ol/layer/Vector";
import {gdAdresseGefoerdertStyle, gdGetVectorSource, gdMaskeStyle, gdStadtteilStyle} from "../gd-ol-functions";
import GdFeatureInfoControl from "./GdFeatureInfoControl";
import VectorSource from "ol/source/Vector";
import {GeoJSON} from "ol/format";

export class GdLayerPicker {
    constructor(map, bgConfig) {
        this.map = map;
        this.layerMenu = $('<ul>').addClass('dropdown-menu');
        this.baseLayers = [];


        this.getLayerControl();
        
        this.addBaseLayers(bgConfig);
        this.addMaskeLayer();
        this.addStadtteilLayer();
        this.addAdresseGefoerdertLayer();
    }




    getLayerControl() {
        let dropdown = $('<div>')
            .addClass('btn-group dropend ol-unselectable ol-control mt-1')
            .append($('<button>')
                .attr('type', 'button')
                .attr('data-bs-toggle', 'dropdown')
                .attr('data-bs-auto-close', 'false')
                .attr('data-bs-offset', '0,10')
                .attr('aria-expanded', 'false')
                .addClass('btn btn-secondary dropdown-toggle')
                .attr('title', 'Layersteuerung anzeigen')
                .html('<i class="fas fa-layer-group fa-xs"></i>')
            )
        ;

        dropdown.append(this.layerMenu);
        $('#gdControls').append(dropdown);
    }
    
    
    
    addAdresseGefoerdertLayer() {
        const gdAdresseGefoerdertLayer = new VectorLayer({
            name: 'gdAdresseGefoerdert',
            source: gdGetVectorSource('/adresse-gefoerdert/features'),
            visible: true,
            style: gdAdresseGefoerdertStyle
        })
        this.map.addLayer(gdAdresseGefoerdertLayer);

        this.layerMenu.prepend($('<li><hr class="dropdown-divider"></li>'));
        this.layerMenu.prepend(this.getLayerToggle(gdAdresseGefoerdertLayer, 'Geförderte Adressen'));

        const gdFeatureInfoControl = new GdFeatureInfoControl(this.map, gdAdresseGefoerdertLayer);
    }



    addStadtteilLayer() {
        const gdStadtteilLayer = new VectorLayer({
            name: 'gdStadtteile',
            source: new VectorSource({
                format: new GeoJSON(),
                url: '/stadtteil/features'
            }),
            visible: true,
            style: gdStadtteilStyle
        })
        this.map.addLayer(gdStadtteilLayer);

        this.layerMenu.prepend($('<li><hr class="dropdown-divider"></li>'));
        this.layerMenu.prepend(this.getLayerToggle(gdStadtteilLayer, 'Stadtteilgrenzen'));
    }



    addMaskeLayer() {
        const gdMaskeLayer = new VectorLayer({
            name: 'gdMaske',
            source: new VectorSource({
                format: new GeoJSON(),
                url: '/stadtteil/maske'
            }),
            visible: true,
            style: gdMaskeStyle
        })
        this.map.addLayer(gdMaskeLayer);
    }





    addBaseLayers(bgConfig) {
        for (const [key, layerConfig] of Object.entries(bgConfig)) {
            this.layerMenu.append(this.addBaseLayerOption(key, layerConfig));
        }

        let gdBaseLayers = new LayerGroup({
            name: 'Basiskarten',
            layers: this.baseLayers
        });
        this.map.setLayerGroup(gdBaseLayers);

        this.setDefaultBaseLayer();
    }



    addBaseLayerOption(key, config) {
        try {
            const layer = new TileLayer({
                name: key,
                type: 'base',
                visible: false,
                source: new TileWMS({
                    url: config.url,
                    params: {'LAYERS': config.layers},
                    crossOrigin: 'Anonymous',
                    transition: 0,
                    attributions: [
                        config.attribution
                    ]
                })
            });

            this.baseLayers.push(layer);

            let button = this.getLayerButton(key, layer, config.label);
            return button;

        } catch (error) {
            console.error(
                `There was an error while creating ${config.label}. ${error}`
            );
        }
    }

    getLayerButton(key, layer, label) {
        let this_ = this;
        let button = $('<li class="dropdown-item">')
            .append($('<div class="form-check">')
                .append($('<input class="form-check-input" type="radio" name="gdBgSwitch"' + (key == 'bkg_grau' ? ' checked' : '') + '>')
                    .attr('id', 'gdBg' + key)
                    .change(function () {
                        this_.changeBaseLayer(layer)
                    })
                )
                .append($('<label class="form-check-label" for="gdBg' + key + '"></label>').html(label))
            )
        ;
        return button;
    }

    getLayerToggle(layer, label) {
        let toggle = $('<li class="dropdown-item">')
            .append($('<div class="form-check form-switch">')
                .append($('<input class="form-check-input" type="checkbox" role="switch" id="gdCheck1" checked>').change(function () {
                    if ($(this).is(":checked")) {
                        layer.setVisible(true);
                    } else {
                        layer.setVisible(false);
                    }
                }))
                .append($('<label class="form-check-label" for="gdCheck1"></label>').html(label))
            )
        ;
        return toggle;
    }

    changeBaseLayer (newLayer) {
        for (var i = 0; i < this.baseLayers.length; i++) {
            var layer = this.baseLayers[i];
            if (layer.get('type') === 'base') {
                if (layer === newLayer) {
                    layer.setVisible(true);
                } else {
                    layer.setVisible(false);
                }
            }
        }
    }

    setDefaultBaseLayer () {
        let baseLayer = this.baseLayers[0];
        this.changeBaseLayer(baseLayer);
    }
}